import {
  EmptyState,
  FlexBox,
  SectionLoader,
} from '@airship-platform/jam-web/components';
import Box, { BoxProps } from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';
import { Product } from '../../../data-access/products/products.models';

interface ProductsListSectionProps extends BoxProps {
  products: Product[];
  searchTerm: string;
  isLoading: boolean;
  isLoaded: boolean;
  onShowAllProducts: () => void;
}

const ProductsQueryEmptyState: React.FC<
  PropsWithChildren<ProductsListSectionProps>
> = ({
  children,
  products,
  searchTerm,
  isLoading,
  isLoaded,
  onShowAllProducts,
  ...rest
}) => {
  if (!products.length && !isLoading && isLoaded) {
    return (
      <EmptyState
        title="No equipment found"
        subtitle={
          <FlexBox flexDirection={'column'} gap={2} minWidth={'280px'}>
            {!!searchTerm && (
              <Box>
                <Typography variant="body2" component={'div'}>
                  No results found for search term{' '}
                  <Typography variant="subtitle2">{searchTerm}</Typography>
                </Typography>
              </Box>
            )}
            <Button fullWidth onClick={onShowAllProducts}>
              Show all products
            </Button>
          </FlexBox>
        }
      />
    );
  }

  if (isLoading) {
    return <SectionLoader isLoading title={'Fetching products...'} />;
  }

  if (isLoaded) {
    return <Box {...rest}>{children}</Box>;
  }

  return null;
};

export default ProductsQueryEmptyState;
